import { render, staticRenderFns } from "./base_snackbar.vue?vue&type=template&id=a2d37e46&scoped=true&"
import script from "./base_snackbar.vue?vue&type=script&lang=ts&"
export * from "./base_snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./base_snackbar.vue?vue&type=style&index=0&id=a2d37e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d37e46",
  null
  
)

export default component.exports